import React from 'react';
import { Dialog, DialogContent, DialogTitle, Grid, Typography, Avatar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getStatusById, getPositionById } from '../../../utils/Enums';

const ViewUserModal = ({ open, onClose, user }) => {
  const { t } = useTranslation();

  const getStatusLabel = (statusId) => {
    const status = getStatusById(statusId);
    return status ? t(status.label) : t('unknown');
  };

  const getPositionLabel = (positionId) => {
    const position = getPositionById(positionId);
    return position ? t(position.label) : t('unknown');
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle><span className="roboto-regular">{t('user_details')}</span></DialogTitle>
      <DialogContent>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <Typography><span className="roboto-regular" style={{fontSize: "18px"}}>{t('personal_information')}</span></Typography>
            <Avatar 
              style={{margin: '12px', marginLeft: '36px'}} 
              alt={`${user.firstName} ${user.lastName}`} 
              src={user.profilePictureUrl} 
              sx={{ width: 100, height: 100 }} 
            />
            <Typography>
              <span className="roboto-regular">{t('name')}: </span> 
              <span className="roboto-light">{user.firstName} {user.lastName}</span> 
            </Typography>
            <Typography>
              <span className="roboto-regular">{t('email')}: </span> 
              <span className="roboto-light">{user.email}</span> 
            </Typography>
            <Typography>
              <span className="roboto-regular">{t('ci')}: </span> 
              <span className="roboto-light">{user.ci}</span> 
            </Typography>
            <Typography>
              <span className="roboto-regular">{t('phone')}: </span> 
              <span className="roboto-light">{user.phone}</span> 
            </Typography>
            <Typography>
              <span className="roboto-regular">{t('address')}: </span> 
              <span className="roboto-light">{user.address}</span> 
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography><span className="roboto-regular" style={{fontSize: "18px"}}>{t('professional_information')}</span></Typography>
            <Typography style={{marginTop:'12px'}}>
              <span className="roboto-regular">{t('role')}: </span> 
              <span className="roboto-light"> {user.role.name}</span> 
            </Typography>
            <Typography>
              <span className="roboto-regular">{t('status')}: </span> 
              <span className="roboto-light"> {getStatusLabel(user.status)}</span> 
            </Typography>
            <Typography>
              <span className="roboto-regular">{t('position')}: </span> 
              <span className="roboto-light"> {getPositionLabel(user.position)}</span> 
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ViewUserModal;
